import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import * as agent from "../agent";
import { MaterialTextField } from "./MaterialInput";
import { required } from "../utility";
import PrimaryDivider from './PrimaryDivider';
import SubmitButton from './SubmitButton';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const feedbackForm = ({user, onSendMessage, handleSubmit}) => {
    const prepareData = data => Object.assign(data, {author: user.fullname})
    return (
        <form className="common-column common-form" onSubmit={handleSubmit(data => onSendMessage(user._id, prepareData(data)))}>
            <Field component={MaterialTextField}
                   name="author"
                   disabled={true}
                   placeholder={user.fullname}/>
            <Field component={MaterialTextField}
                   validate={required}
                   name="email"
                   label="Обратный адрес" />
            <Field component={MaterialTextField}
                   validate={required}
                   name="subject"
                   label="Тема сообщения" />
            <Field component={MaterialTextField}
                   rows={5}
                   validate={required}
                   multiline
                   name="message"
                   label="Текст сообщения" />
            <SubmitButton label="Отправить" />
        </form>
)};

export const FeedbackForm = reduxForm({ form: "feedback" })(feedbackForm)

class Feedback extends React.Component {

    render() {
        const { user, onSendMessage } = this.props

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4" >Обратная связь</Typography>
                    <PrimaryDivider />
                    <Grid container justify="flex-start">
                        <Grid item>
                            <Paper className="common-paper">
                                <FeedbackForm user={user} onSendMessage={onSendMessage} />
                            </Paper>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </Fade>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
    user: state.common.user || {}
});

const mapDispatchToProps = dispatch => ({
    onSendMessage: (id, data) =>
        agent.User.sendMessage(id, data)
        .then(() => alert("Сообщение успешно отправлено")),
});


export default connect(mapStateToProps, mapDispatchToProps)(Feedback);



// WEBPACK FOOTER //
// ./src/components/Feedback.js